import { StaticTimePicker } from '@mui/lab';
import type { ToolbarComponentProps } from '@mui/lab/internal/pickers/typings/BasePicker.js';
import TimePickerToolbar, {
  timePickerToolbarClasses,
} from '@mui/lab/TimePicker/TimePickerToolbar.js';
import { generateUtilityClass, styled, TextField } from '@mui/material';
import type { DateTime } from 'luxon';
import type { FC } from 'react';

const selectedToolbarTextClass = generateUtilityClass(
  'PrivatePickersToolbarText',
  'selected',
);

const PatrolTimePickerToolbar = styled(TimePickerToolbar)(({ theme }) => ({
  [`& .${timePickerToolbarClasses.ampmLabel}.${selectedToolbarTextClass}`]: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: 999,
    boxShadow: `0 0 0 4px ${theme.palette.primary.main}`,
    color: theme.palette.primary.contrastText,
  },
})) as FC<ToolbarComponentProps<DateTime | null>>;

interface PatrolTimePickerProps {
  disabled: boolean;
  onChange: (value: DateTime | null) => void;
  value: DateTime;
}

export const PatrolTimePicker: FC<PatrolTimePickerProps> = ({
  disabled,
  onChange,
  value,
}) => (
  <div className="date-wrapper">
    <StaticTimePicker<DateTime>
      disabled={disabled}
      displayStaticWrapperAs="mobile"
      onChange={onChange}
      renderInput={(params: object) => <TextField {...params} />}
      ToolbarComponent={PatrolTimePickerToolbar}
      toolbarTitle="Patrol start time"
      value={value}
    />
  </div>
);
